var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramDonations64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Donations64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(6.000000, 19.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(0.000000, 0.612903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,21.3870968 C10,21.3870968 28.6153846,26.3870968 30,26.3870968 C31.3846154,26.3870968 54,15.3870968 54,15.3870968 C54,15.3870968 53.5384615,9.38709677 48,9.38709677 C46.6153846,9.38709677 38,11.3870968 38,11.3870968 C38,11.3870968 38.1538462,7.38709677 34,7.38709677 C29.8461538,7.38709677 29,7.38709677 29,7.38709677 C29,7.38709677 27.402832,1.37415732 21,2.38709677 C21,2.38709677 11.2635025,4.38709677 12,4.38709677 C10.6153846,4.38709677 9.69230769,7.41935484 9.69230769,7.41935484 L10,21.3870968 Z",
    id: "Path-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,11.3870968 C38,11.3870968 38,15.3870968 35.2,15.3870968 L24,15.3870968",
    id: "Path-10",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#FFCC00",
    x: 0,
    y: 0.387096774,
    width: 12,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramDonations64);
export default __webpack_public_path__ + "static/media/pictogramDonations64.beff33d43c4779b34e532dbd732432a0.svg";
export { ForwardRef as ReactComponent };